package ai.jessie.web.settings

import ai.jessie.shared.settings.TaxonomyProposal
import ai.jessie.web.theme.FormStackStyle
import ai.jessie.web.theme.Grid2Style
import androidx.compose.runtime.Composable
import com.varabyte.kobweb.silk.style.toAttrs
import org.jetbrains.compose.web.dom.Div

// Dokumentkategorien / Dokumentordner as cards of the form; stored entries keep their status
// select, new entries can be discarded before the preview.
@Composable
internal fun taxonomyCard(
    kind: String,
    state: SettingsUiState,
    rows: List<TaxonomyProposal>,
    footer: (@Composable () -> Unit)? = null,
    change: ((List<TaxonomyProposal>) -> List<TaxonomyProposal>) -> Unit,
) {
    val label = if (kind == "documentCategories") "Dokumentkategorien" else "Dokumentordner"
    groupCard(
        label,
        "Namen (1–100 Zeichen) sind einschliesslich archivierter Einträge eindeutig und " +
            "unterscheiden Gross-/Kleinschreibung. Archivieren verhindert neue Zuweisungen; " +
            "bestehende Referenzen bleiben erhalten.",
        footer = footer,
    ) {
        rows.forEachIndexed { index, row -> taxonomyRow(kind, label, index, row, state, change) }
        smallAction("$label: Eintrag hinzufügen", state.busy) {
            change { it + TaxonomyProposal("") }
        }
    }
}

@Composable
private fun taxonomyRow(
    kind: String,
    label: String,
    index: Int,
    row: TaxonomyProposal,
    state: SettingsUiState,
    change: ((List<TaxonomyProposal>) -> List<TaxonomyProposal>) -> Unit,
) {
    val prefix = "$kind[$index]"
    val name =
        SettingsField(
            "$prefix.name",
            "$label ${index + 1}: Name",
            row.name,
            state.problems["$prefix.name"],
        )
    val rename: (String) -> Unit = { value ->
        change { it.updated(index) { row -> row.copy(name = value) } }
    }
    if (row.id != null) {
        Div(attrs = Grid2Style.toAttrs()) {
            settingsField(name, rename)
            settingsSelect(
                SettingsField(
                    "$prefix.active",
                    "$label ${index + 1}: Status",
                    row.active.toString(),
                    state.problems["$prefix.active"],
                ),
                mapOf("true" to "Aktiv", "false" to "Archiviert"),
            ) { value ->
                change { it.updated(index) { row -> row.copy(active = value == "true") } }
            }
        }
    } else
        Div(attrs = FormStackStyle.toAttrs()) {
            settingsField(name, rename)
            smallAction("$label ${index + 1}: neuen Eintrag verwerfen", state.busy) {
                change { it.filterIndexed { i, _ -> i != index } }
            }
        }
}
